import { Box } from '@mui/material'
import { MediaCard } from './MediaCard'

export const PostList = ({ media }) => {
    return (
        <Box sx={{ columnCount: { xs: 2, sm: 3 }, columnGap: '8px', p: 1 }}>
            {media.map((item) =>
                item.img ? (
                    <Box key={item.id} sx={{ breakInside: 'avoid', mb: '8px' }}>
                        <MediaCard item={item} />
                    </Box>
                ) : null
            )}
        </Box>
    )
}
